import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './styles/globals.css';

// Components
import { Layout } from './components/layout/Layout';
import { ProjectSettingsPage } from './pages/ProjectSettingsPage';
import { ChatPage } from './pages/ChatPage';
import { DashboardPage } from './pages/DashboardPage';
import { GoogleIntegrationPage } from './pages/GoogleIntegrationPage';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { OmnichannelPage } from './pages/OmnichannelPage';
import { RegisterPage } from './pages/RegisterPage';
import { WelcomePage } from './pages/WelcomePage';
import { CompanyPage } from './pages/CompanyPage';
import { CompanySettingsPage } from './pages/CompanySettingsPage';
import { InvitationPage } from './pages/InvitationPage';
import { AISetupWizardPage } from './pages/AISetupWizardPage';

// Providers
import { ApiProvider } from './providers/ApiProvider';
import { AuthProvider } from './providers/AuthProvider';
import { CompanyProjectProvider } from './providers/CompanyProjectProvider';

// Routes
import { ProtectedRoute } from './components/auth/ProtectedRoute';

function App() {
  return (
    <div className="App">
      <ApiProvider>
        <AuthProvider>
          <CompanyProjectProvider>
            <Router>
              <Layout>
                <Routes>
                  {/* Public routes */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/welcome" element={<WelcomePage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route
                    path="/chat"
                    element={
                      <ChatPage />
                    }
                  />
                  
                  {/* Invitation route (can be accessed before auth) */}
                  <Route path="/invitations/:token" element={<InvitationPage />} />

                  {/* Protected routes */}
                  <Route
                    path="/dashboard"
                    element={
                      <ProtectedRoute>
                        <DashboardPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/omnichannel"
                    element={
                      <ProtectedRoute>
                        <OmnichannelPage />
                      </ProtectedRoute>
                    }
                  />
                  
                  {/* Company routes */}
                  <Route
                    path="/companies/:companyId"
                    element={
                      <ProtectedRoute>
                        <CompanyPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/companies/:companyId/settings"
                    element={
                      <ProtectedRoute>
                        <CompanySettingsPage />
                      </ProtectedRoute>
                    }
                  />
                  
                  {/* Project routes */}
                  <Route
                    path="/projects/:projectId/settings"
                    element={
                      <ProtectedRoute>
                        <ProjectSettingsPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/projects/:projectId/ai-setup"
                    element={
                      <ProtectedRoute>
                        <AISetupWizardPage />
                      </ProtectedRoute>
                    }
                  />
                  
                  {/* Integration routes */}
                  <Route
                    path="/integrations/google"
                    element={
                      <ProtectedRoute>
                        <GoogleIntegrationPage />
                      </ProtectedRoute>
                    }
                  />

                  {/* Catch all route */}
                  <Route path="*" element={<div>Page not found</div>} />
                </Routes>
              </Layout>
            </Router>
          </CompanyProjectProvider>
        </AuthProvider>
      </ApiProvider>
    </div>
  );
}

export default App;

